export const authMixin = {
    methods: {
        async handleLogout() {
            try {
                const response = await this.$http.post(
                    process.env.LOGOUT,
                    {},
                    {
                        headers: {
                            "Asani-Token": localStorage.getItem("jwt"),
                        },
                    }
                );
                if (response.data.status !== 200) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    });
                    return;
                }
            } catch (error) {
                if (error.response.data.status != 401) {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    });
                    return;
                }
            }
            localStorage.removeItem("jwt");
            localStorage.removeItem("admin_name");
            localStorage.removeItem("roles");
            localStorage.removeItem("user_email");
            localStorage.removeItem("admin_id");
            localStorage.removeItem("changeCatalogPermission");
            this.$router.push("/");
        },
    },
};


// WEBPACK FOOTER //
// ./src/mixins/auth.js